import { css } from '@creditas/stylitas'

const containerBase = css`
  min-height: calc(100vh - 180px);
`

export { containerBase }
